// Ported verbatim from smartpay-pos/src/utils/ClearPhone.jsx - same normalization the POS already
// applies before sending a phone to Yappy (see ModalPayMet.jsx's ModalPhoneSaveYappy). Yappy's
// aliasYappy field expects a bare 8-digit Panama number - a customer typing it with dashes/spaces
// (the ModalYappyBtn placeholder itself shows "6000-0000") or a "+507"/"507" prefix gets silently
// rejected by Yappy's own API, which smartpay-dashboard's createYappyBtnOrder then reports back as a
// flat 400 with no obvious cause.
export const ClearPhone = (phone) => {
    if (!phone || typeof phone !== "string") {
        return ""; // Retorna una cadena vacía si el valor no es válido
    }

    let clear = phone.replace(/[\s-]/g, ""); // Remove spaces and dashes
    // Check if the phone number starts with "+507" or "507"
    if (clear.startsWith("+507")) {
        clear = clear.slice(4); // Remove "+507"
    } else if (clear.startsWith("507")) {
        clear = clear.slice(3); // Remove "507"
    }
    return clear; // Return the cleaned phone number
}
